// extracted by mini-css-extract-plugin
export default {"label":"CustomLabelGroup_label__cRKKp","container":"CustomLabelGroup_container__2DxQ6"};